import React from 'react';
import { observer } from 'mobx-react';
import { SuccessIcon } from 'app/commonComponents/icons';
import form from 'modules/ticketPublicPage/stores/tickets/form';
import { colors } from 'app/variables';
import {
  FlexContainer,
  HeaderBox,
  CheckIcon,
  ReturnButton,
} from './styles/_confirmation';
import DetailsContainer from './DetailsContainer';

const Confirmation = observer(() => {
  const { onNextBtnClick } = form;

  return (
    <FlexContainer>
      <HeaderBox>
        <CheckIcon>
          <SuccessIcon style={{ height: '3.5rem', width: '3.5rem' }} />
        </CheckIcon>
        <div style={{ fontSize: '1.75rem' }}>{i18n.gettext('Thank you!')}</div>
      </HeaderBox>
      <DetailsContainer />
      <ReturnButton onClick={onNextBtnClick} color={colors.pacificBlue}>
        {i18n.gettext('Buy another ticket')}
      </ReturnButton>
      <div style={{ fontSize: '0.75rem' }}>
        {i18n.gettext(
          'We have sent you an email with a confirmation of your purchase and all important information.'
        )}
      </div>
    </FlexContainer>
  );
});

export default Confirmation;
